var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useStore } from "effector-react";
import { Typography, Box, TableContainer, Table, TableBody, Paper, useMediaQuery, useTheme, } from "@material-ui/core";
import { DataTableLayout } from "frontend/src/ui/data-table-layout";
import { $hasAnyTimetables, $isPageLoaded, $timetables, pageMounted, pageUnmounted, } from "./model";
import { DesktopTimetableRow, MobileTimetableRow } from "./timetable-row";
import { EmployeeUserLayout } from "frontend/src/pages/layouts";
var Timetables = function () {
    var theme = useTheme();
    var timetables = useStore($timetables);
    var showMobileTable = useMediaQuery(theme.breakpoints.down("xs"));
    var TimetableRowComponent = showMobileTable
        ? MobileTimetableRow
        : DesktopTimetableRow;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mt: 2 },
            React.createElement(TableContainer, { component: Paper },
                React.createElement(Table, null,
                    React.createElement(TableBody, null, timetables.map(function (timetable) { return (React.createElement(TimetableRowComponent, __assign({ key: timetable.id }, timetable))); })))))));
};
var Page = function () {
    var hasAnyTimetables = useStore($hasAnyTimetables);
    var table;
    if (hasAnyTimetables) {
        table = React.createElement(Timetables, null);
    }
    else {
        table = (React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Typography, null, "\u041F\u043E\u043A\u0430 \u0447\u0442\u043E \u0437\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u0441\u0435\u0442\u043A\u0438 \u0432\u0435\u0449\u0430\u043D\u0438\u044F.")));
    }
    return React.createElement(DataTableLayout, { table: table });
};
export var TimetablesPage = function () {
    var isLoaded = useStore($isPageLoaded);
    React.useEffect(function () {
        pageMounted();
        return pageUnmounted;
    }, []);
    return React.createElement(EmployeeUserLayout, null, isLoaded ? React.createElement(Page, null) : null);
};
